module.exports = __webpack_public_path__ + "static/img/congratulation.cc989eb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/congratulation.png
// module id = 74
// module chunks = 1